import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import Connected from './connected'
import Disconnected from './disconnected'
import { withRouter } from 'react-router'

class App extends Component {
  render() {
    const { isAuthenticated } = this.props
    return (
      <Switch>
        <Route path="/" render={ (props) => isAuthenticated ? <Connected {...props} /> : <Disconnected />} />
        )} />
      </Switch>
    )
  }
}

App.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
}


function mapStateToProps(state) {

  const { auth, routing } = state
  const { isAuthenticated } = auth

  return {
    isAuthenticated,
    routing
  }
}

export default withRouter(connect(mapStateToProps)(App))



// WEBPACK FOOTER //
// ./src/containers/app/index.js